import { InfluencerLoginPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(InfluencerLoginPage);
